import moment from 'moment-timezone';
import { DateTime } from 'luxon';
import { ConsultationType } from '../types';

export const getPastConsultations = (consultations: ConsultationType[]) => {
  return consultations.filter(
    (s) => consultationTimeToFormatSeconds(s.consultation_time) + 3600 < DateTime.local().toSeconds()
  );
};

export const showConsultationTime = (time: number): string => {
  const givenDay = moment(time * 1000).tz(Intl.DateTimeFormat().resolvedOptions().timeZone);

  const today = moment();
  const month = [
    'січня',
    'лютого',
    'березня',
    'квітня',
    'травня',
    'червня',
    'липня',
    'серпня',
    'вересня',
    'жовтня',
    'листопада',
    'грудня',
  ];

  if (givenDay.format('DD') + givenDay.day === today.format('DD') + today.day)
    return 'Сьогодні ' + givenDay.format('HH:mm');
  else return givenDay.format('DD ') + month[givenDay.month()] + givenDay.format(' HH:mm');
};

export const consultationTimeToFormatSeconds = (consultation_time: ConsultationType['consultation_time']) => {
  return typeof consultation_time === 'string'
    ? DateTime.fromISO(consultation_time).toSeconds()
    : consultation_time._seconds;
};

export const consultationTimeToFormatSecondsWithUndefinedCase = (
  consultation_time?: ConsultationType['consultation_time']
) => {
  if (!consultation_time) return undefined;

  return typeof consultation_time === 'string'
    ? DateTime.fromISO(consultation_time).toSeconds()
    : consultation_time?._seconds;
};
